import type { IPixellotPlayerSource, IPixellotPlayerSourceType } from "~~/modules/pixellot-sdk";

import type { IResponseClip, IResponseHighlight, IResponsePlayerHighlight } from "./event-clips";
import type { IResponseEvent } from "./events";
import type { IResponsePlaylist } from "./playlists";

export type TVideoType = "event" | "mbe-event" | "clip" | "highlight" | "autohighlight" | "player-highlight";

export const VIDEO_SOURCE_TYPE = {
  CONTINUOUS: "continuous",
  CLIPPED: "clipped",
} as const;
export type TVideoSourceType = (typeof VIDEO_SOURCE_TYPE)[keyof typeof VIDEO_SOURCE_TYPE];

export type TBasicVideoURL = IPixellotPlayerSource & {
  mp4_url?: string;
  duration?: number;
  videoType?: TVideoSourceType;
};

export type TBasicVideoUrls = TBasicVideoURL[];
export type TBasicVideoUrlsMap = Map<IPixellotPlayerSourceType, TBasicVideoURL>;

export interface IBasicVideo {
  id: string;
  eventId: string; // Every video should have associated eventId.
  eventAbeId?: string;
  favoriteId?: string;
  type: TVideoType;
  source_type: "video";
  title: string;
  created_at: string | Date;
  views_count: number;
  video_duration?: number;
  poster?: string;
  urls: TBasicVideoUrlsMap;
  is_favorite: boolean;
  permissions: {
    canAddToFavorites: boolean;
    canDownloadVideoWithoutLogin: boolean;
  };
}

export interface IResponseFavoriteVideos {
  data: IResponseFavoriteVideo[];
  meta: {
    total: number;
  };
}

export interface IResponseFavoriteVideo {
  id: string;
  type: TVideoType | "playlist";
  attributes:
    | IResponseEvent["attributes"]
    | IResponseClip["attributes"]
    | IResponseHighlight["attributes"]
    | IResponsePlayerHighlight["attributes"]
    | IResponsePlaylist["attributes"];
  relationships?: {
    favorite?: IResponseFavoriteVideo;
  };
  meta: {
    createdAt: Date | string;
    updatedAt: Date | string;
  };
}
